import { STATE_ABBREVIATIONS } from 'constants/stateAbbreviations';

interface IGeneratePodNameInput {
  podType: 'RPM' | 'CCM';
  states: string[];
  clinicNames: string[];
}

export function generatePodName({
  podType,
  states,
  clinicNames,
}: IGeneratePodNameInput): string {
  const validClinics = clinicNames
    .map((c) => c.trim())
    .filter((c) => c.length > 0);

  let clinicSuffix = 'New Pod';
  if (validClinics.length > 0) {
    const primaryClinic = validClinics[0];
    const additionalCount = validClinics.length - 1;
    clinicSuffix =
      additionalCount > 0
        ? `${primaryClinic} +${additionalCount}`
        : primaryClinic;
  }

  if (podType === 'CCM') {
    return `CCM - ${clinicSuffix}`;
  }

  // RPM: trim and convert full state names to abbreviations
  const stateAbbrs = states
    .map((s) => s.trim())
    .filter((s) => s.length > 0)
    .map((s) => STATE_ABBREVIATIONS[s] || s);

  if (stateAbbrs.length === 0) {
    return `RPM - ${clinicSuffix}`;
  }

  return `RPM - ${stateAbbrs.join('/')} - ${clinicSuffix}`;
}
